import request from '@/utils/request'

function baseApi(options) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        ...options,
    })
}

export default baseApi;


// WEBPACK FOOTER //
// ./src/areas/systemmanage/api/baseApi.js